import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import reduxUtils from '../../util/redux';
import PropTypes from 'prop-types';
import { Trans } from 'translations';
import Icon from 'components/icon';

class OfflineNotification extends PureComponent {
    static propTypes = {
        isOnline: PropTypes.bool,
    };

    render() {
        const { isOnline } = this.props;

        if (isOnline) {
            return null;
        }

        return (
            <div className="offline-notification grid">
                <div className="offline-notification--container grid--container offline-notification__fluid">
                    <div className="browser-support--inner">
                        <div className="offline-notification--content">
                            <Icon size="medium" className="offline-notification--icon" symbol="alert-small" />
                            <div className="browser-support--message">
                                <Trans path={'error.is_offline'} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default connect(
    reduxUtils.mapStateToProps({
        isOnline: 'navigator.isOnline',
    }),
)(OfflineNotification);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/offline-notification/index.js